module.exports = __webpack_public_path__ + "static/media/01A.b5408b85.png";